<aside class="sidebar-message">
    <div class="sidebar-overlay"></div>

    <div class="sidebar-top">
        <img class="sidebar-logo" src="/assets/img/logo-white.svg" alt="logo">
    </div>

    <!--
    <div class="sidebar-bottom">
        <nav class="sidebar-navigation">
        <ul>
            <li *ngFor="let nb of [ 1, 2, 3 ]" [class.active]="currentSlide === nb" (click)="changeSlide(nb)"></li>
        </ul>
        </nav>
    </div>

    <div class="sidebar-slides">
        <div class="sidebar-slide" *ngFor="let i of [ 1, 2, 3, 4 ]" [class.shown]="currentSlide === i">
            <strong>{{ 'shared.sidebar.intro-' + i + '-title' | translate }} — </strong>
            {{ 'shared.sidebar.intro-' + i + '-text' | translate }}
        </div>
    </div>
    -->

    <app-lang-switcher></app-lang-switcher>
</aside>
